// src/components/constants.js
export const DRAWER_OPEN_WIDTH = 220;
export const DRAWER_CLOSE_WIDTH = 64;
export const APPBAR_HEIGHT = 64;